import { Area } from 'react-easy-crop';

export const ALLOWED_AVATAR_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
];
export const MAX_AVATAR_SIZE_BYTES = 5 * 1024 * 1024;

export const readFileAsDataUrl = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const getCroppedBase64 = async (
  srcDataUrl: string,
  area: Area
): Promise<string> => {
  const img = new Image();
  img.src = srcDataUrl;
  await new Promise<void>((resolve, reject) => {
    img.onload = () => {
      resolve();
    };
    img.onerror = () => {
      reject(new Error('Failed to load image for cropping'));
    };
  });

  const canvas = document.createElement('canvas');
  canvas.width = area.width;
  canvas.height = area.height;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas context unavailable');
  ctx.drawImage(
    img,
    area.x,
    area.y,
    area.width,
    area.height,
    0,
    0,
    area.width,
    area.height
  );

  const blob = await new Promise<Blob | null>((resolve) => {
    canvas.toBlob(resolve, 'image/jpeg', 0.9);
  });
  if (!blob) throw new Error('Failed to encode cropped image');

  const dataUrl = await readFileAsDataUrl(blob as unknown as File);
  // Strip the "data:image/jpeg;base64," prefix — User.image stores raw base64.
  return dataUrl.split(',')[1];
};
